import { render, staticRenderFns } from "./RefundOnGoingSchemes.vue?vue&type=template&id=2a425bfa"
import script from "./RefundOnGoingSchemes.vue?vue&type=script&lang=js"
export * from "./RefundOnGoingSchemes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports